var map = {
	"./ar.json": "5041",
	"./chi.json": "61d2",
	"./en.json": "e90f",
	"./fr.json": "c463",
	"./gr.json": "33ad",
	"./hi.json": "3378",
	"./sp.json": "7d84"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "119d";